import { useLayoutEffect as o, useEffect as e } from "react";
var f = globalThis != null && globalThis.document ? o : e;
export {
  f as u
};
